if (!window.FeaturedCollectionCarousel) {
  window.FeaturedCollectionCarousel = class {
    constructor(element) {
      this.carousel = element;
      this.grid = this.carousel.querySelector('.featured-collection__grid');
      this.prevButton = this.carousel.querySelector('[data-carousel-prev]');
      this.nextButton = this.carousel.querySelector('[data-carousel-next]');
      this.dots = Array.from(this.carousel.querySelectorAll('[data-carousel-dot]'));
      this.items = Array.from(this.grid.querySelectorAll('.featured-collection__item'));
      this.currentPage = 0;
      this.itemsPerPage = 3;
      
      if (!this.grid || this.items.length === 0) return;
      
      this.init();
    }

    init() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scrollPrev());
      }
      
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollNext());
      }

      for (const dot of this.dots) {
        dot.addEventListener('click', () => {
          const page = parseInt(dot.dataset.carouselDot);
          this.goToPage(page);
        });
      }

      let scrollTimeout;
      this.grid.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          this.updateActive();
        }, 100);
      });
      
      setTimeout(() => this.updateActive(), 100);

      let isDown = false;
      let startX;
      let scrollLeft;

      this.grid.addEventListener('mousedown', (e) => {
        isDown = true;
        this.grid.style.cursor = 'grabbing';
        startX = e.pageX - this.grid.offsetLeft;
        scrollLeft = this.grid.scrollLeft;
      });

      this.grid.addEventListener('mouseleave', () => {
        isDown = false;
        this.grid.style.cursor = 'grab';
      });

      this.grid.addEventListener('mouseup', () => {
        isDown = false;
        this.grid.style.cursor = 'grab';
      });

      this.grid.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - this.grid.offsetLeft;
        const walk = (x - startX) * 2;
        this.grid.scrollLeft = scrollLeft - walk;
      });
    }

    updateActive() {
      const scrollLeft = this.grid.scrollLeft;
      const items = Array.from(this.grid.querySelectorAll('.featured-collection__item'));
      
      if (items.length === 0) return;

      const isMobile = window.innerWidth <= 749;
      
      if (isMobile) {
        const firstItem = items[0];
        const itemWidth = firstItem.offsetWidth;
        const gap = parseFloat(getComputedStyle(this.grid).gap) || 20;
        const itemWithGap = itemWidth + gap;
        const currentPage = Math.round(scrollLeft / itemWithGap);
        this.currentPage = Math.max(0, Math.min(currentPage, this.dots.length - 1));
      } else {
        const gridWidth = this.grid.offsetWidth;
        const currentPage = Math.round(scrollLeft / gridWidth);
        this.currentPage = Math.max(0, Math.min(currentPage, this.dots.length - 1));
      }

      this.dots.forEach((dot, index) => {
        if (index === this.currentPage) {
          dot.classList.add('featured-collection__dot--active');
        } else {
          dot.classList.remove('featured-collection__dot--active');
        }
      });

      if (this.prevButton) {
        this.prevButton.disabled = this.currentPage === 0;
      }
      
      if (this.nextButton) {
        this.nextButton.disabled = this.currentPage >= this.dots.length - 1;
      }
    }

    goToPage(page) {
      if (page < 0 || page >= this.dots.length) return;
      
      const items = Array.from(this.grid.querySelectorAll('.featured-collection__item'));
      if (items.length === 0) return;

      const isMobile = window.innerWidth <= 749;
      
      if (isMobile) {
        const firstItem = items[0];
        const itemWidth = firstItem.offsetWidth;
        const gap = parseFloat(getComputedStyle(this.grid).gap) || 20;
        const itemWithGap = itemWidth + gap;
        const scrollPosition = page * itemWithGap;
        
        this.grid.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      } else {
        const gridWidth = this.grid.offsetWidth;
        const scrollPosition = page * gridWidth;
        
        this.grid.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
    }

    scrollPrev() {
      if (this.currentPage > 0) {
        this.goToPage(this.currentPage - 1);
      }
    }

    scrollNext() {
      if (this.currentPage < this.dots.length - 1) {
        this.goToPage(this.currentPage + 1);
      }
    }
  };
}

if (!window.addToCart) {
  window.addToCart = function(button) {
    const variantId = button.dataset.productId;
    
    if (!variantId) {
      console.error('Variant ID not found');
      return;
    }

    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    const cart = cartDrawer || cartNotification;

    button.disabled = true;
    const originalContent = button.innerHTML;
    button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><path d="M12 6v6l4 2"></path></svg>';

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }
    };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cart && cart.getSectionsToRender) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) {
        cart.setActiveElement(button);
      }
    }
    config.body = formData;

    const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(cartAddUrl, config)
    .then((response) => {
      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('application/json') || contentType.includes('application/javascript') || contentType.includes('text/javascript')) {
        return response.json();
      }
      return response.text().then(text => {
        try {
          return JSON.parse(text);
        } catch (e) {
          console.error('Resposta não é JSON válido:', text.substring(0, 200));
          throw new Error('Resposta do servidor não é válida. Tente novamente.');
        }
      });
    })
    .then((response) => {
      if (response.status) {
        throw new Error(response.description || 'Erro ao adicionar produto ao carrinho');
      }

      if (!cart) {
        if (window.routes && window.routes.cart_url) {
          window.location = window.routes.cart_url;
        } else {
          window.location = '/cart';
        }
        return;
      }

      if (cart && cart.renderContents) {
        cart.renderContents(response);
      } else {
        button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>';
        setTimeout(() => {
          button.innerHTML = originalContent;
          button.disabled = false;
        }, 1500);
        return;
      }

      setTimeout(() => {
        button.innerHTML = originalContent;
        button.disabled = false;
      }, 300);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.innerHTML = originalContent;
      button.disabled = false;
      alert(error.message || 'Erro ao adicionar produto ao carrinho. Tente novamente.');
    });
  };
}

function initFeaturedCollections() {
  const carousels = document.querySelectorAll('[data-featured-carousel]');
  
  for (const carousel of carousels) {
    // Só inicializa o carrossel no mobile (largura <= 989px)
    if (window.innerWidth <= 989) {
      new window.FeaturedCollectionCarousel(carousel);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeaturedCollections);
} else {
  initFeaturedCollections();
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const carousel = event.target.querySelector('[data-featured-carousel]');
    if (carousel && window.innerWidth <= 989) {
      new window.FeaturedCollectionCarousel(carousel);
    }
  });
}

// Desabilitar carrossel no desktop ao redimensionar
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const carousels = document.querySelectorAll('[data-featured-carousel]');
    carousels.forEach(carousel => {
      // Remove instâncias existentes e recria apenas se for mobile
      if (window.innerWidth > 989) {
        // No desktop, garante que o grid não tenha scroll
        const grid = carousel.querySelector('.featured-collection__grid');
        if (grid) {
          grid.style.overflowX = 'visible';
          grid.style.overflowY = 'visible';
        }
      }
    });
  }, 250);
});
